export const isImage = (mimeType: string) => {
  const imageMimeTypeReg = /image\/.*/
  return imageMimeTypeReg.test(mimeType)
}

export const getMimeType = (fileName?: string) => {
  const matches = fileName?.match(/\.[a-zA-Z]{1,4}$/i)
  const fileExtension = matches?.[0]

  switch (fileExtension) {
    case '.docx':
      return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    case '.doc':
      return 'application/msword'
    case '.ttf':
      return 'font/ttf'
  }
}

export const getHumanReadableSize = (bytes: number, decimals?: number) => {
  if (bytes === 0) {
    return '0 Bytes'
  }

  const k = 1024
  const dm = decimals ? decimals + 1 : 2
  const sizes = ['Bytes', 'Kb', 'Mb', 'Gb']
  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return `${Number.parseFloat((bytes / k ** i).toFixed(dm))} ${sizes[i]}`
}
